export default [
  {
    type: 'quickbooks',
    name: 'Quickbooks',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
  {
    type: 'sage',
    name: 'Sage',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
  {
    type: 'xero',
    name: 'Xero',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
  {
    type: 'googleDrive',
    name: 'Google Drive',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
  {
    type: 'googleSheets',
    name: 'Google Sheets',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
  {
    type: 'dropbox',
    name: 'Dropbox',
    status: 'connected',
    lastSyncOn: '08 Aug 2018, 18:45',
  },
]
